import { render, staticRenderFns } from "./articleSummaryTable.vue?vue&type=template&id=5cdfc75e&scoped=true"
import script from "./articleSummaryTable.vue?vue&type=script&lang=ts"
export * from "./articleSummaryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdfc75e",
  null
  
)

export default component.exports